// features/auth — PUBLIC BARREL.
// GrowithNSI central SSO for the Meet website (create + salesperson-join
// only — the public lead-join page never imports this). Flag-gated via
// NEXT_PUBLIC_SSO_ENABLED, default off; see MIHIR-RESPONSE-web-token-mechanism.md.

export { useAuthBootstrap } from './useAuthBootstrap';
export { getAccessToken, getDisplayUser, isHostInjected, type CurrentUser } from './token';
export { logout } from './sso-client';
